import { useFretboardConfigStore } from '@/features/fretboard-base';
import React from 'react';

export const HandednessSelector: React.FC = () => {
  const isLeftHanded = useFretboardConfigStore((state) => state.isLeftHanded);
  const setIsLeftHanded = useFretboardConfigStore((state) => state.setIsLeftHanded);

  const handleChange = () => {
    setIsLeftHanded(!isLeftHanded);
  };

  return (
    <div className="form-control w-full mb-3 max-w-full">
      <label className="label">
        <span className="label-text">Handedness</span>
      </label>
      <div className="flex items-center justify-between">
        <span className="text-sm opacity-70">{isLeftHanded ? 'Left-handed' : 'Right-handed'}</span>
        <input
          type="checkbox"
          className="toggle toggle-primary"
          checked={isLeftHanded}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};
